import { createRouter, createWebHistory } from 'vue-router'

let docsScrollTop = 0
const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (to, from, saved) => {
    if (saved) return saved
    if (to.path === '/docs' && from.path.startsWith('/docs/')) return { top: docsScrollTop }
    if (to.hash) {
      let target: HTMLElement | null = null
      try { target = document.getElementById(decodeURIComponent(to.hash.slice(1))) } catch { /* Invalid hashes return to the page start. */ }
      if (target) return {
        el: target,
        top: Number.parseFloat(getComputedStyle(target).scrollMarginTop) || 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      }
    }
    return { top: 0 }
  },
  routes: [
    { path: '/', name: 'home', component: () => import('../pages/NewHomePage.vue') },
    { path: '/home', redirect: '/' },
    { path: '/download', name: 'download-page', component: () => import('../pages/DownloadPage.vue') },
    ...(import.meta.env.DEV ? [
      { path: '/experience', name: 'experience', component: () => import('../pages/HomePage.vue') },
      { path: '/quick', name: 'quick-home', component: () => import('../pages/QuickHomePage.vue') }
    ] : []),
    { path: '/docs', name: 'docs', component: () => import('../pages/DocsPage.vue') },
    { path: '/docs/developers/:slug?', name: 'developer-docs', component: () => import('../pages/DeveloperDocsPage.vue') },
    { path: '/docs/:slug', name: 'doc', component: () => import('../pages/DocDetailPage.vue') },
    { path: '/changelog', name: 'changelog', component: () => import('../pages/ChangelogPage.vue') },
    { path: '/privacy', name: 'privacy', component: () => import('../pages/PrivacyPage.vue') },
    { path: '/about', name: 'about', component: () => import('../pages/AboutPage.vue') },
  ],
})

router.beforeEach((to, from) => {
  if (from.path === '/docs') docsScrollTop = window.scrollY
  if (to.path === '/docs' && !from.path.startsWith('/docs/')) docsScrollTop = 0
})

export default router
